import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import {deleteProductStock} from '../../../../../../../../crud/management_api/stock_management';
import { HiXMark } from 'react-icons/hi2';
import { toast } from 'react-toastify';


interface DeleteStockProps {
    product_id: string;
    storage_unit_id: number;
    setProductStockData: (data: any) => void;
    productStockData: any;
    show: boolean;
    handleClose: () => void;
}

const DeleteStock: React.FC<DeleteStockProps> = ({
    product_id,
    storage_unit_id,
    setProductStockData,
    productStockData,
    show, 
    handleClose}) => {
    const [loading, setLoading] = useState(false);

    function handleDelete() {
        setLoading(true);
        deleteProductStock(product_id, storage_unit_id).then((response) => {
            toast.success('Stock eliminado exitosamente');
            // Eliminar solo el productStock que coincida con product_id y storage_unit_id
            const newData = productStockData.filter((stock: any) => !(stock.product_id === product_id && stock.storage_unit_id === storage_unit_id));
            setProductStockData(newData);
            handleClose();
        }).catch((error) => {
            console.error('Error deleting stock:', error);
            toast.error('Error al eliminar el stock');
        }).finally(() => setLoading(false));
    }

    return (
        <Modal show={show} onHide={handleClose} dialogClassName="mp-modal">
            <Modal.Header className="mp-modal-header">
                <div className="form-modal-title-container">
                    <span className="form-modal-title">Eliminar Stock</span>
                </div>
                <button className="mp-modal-close" onClick={handleClose} disabled={loading}>
                    <HiXMark size={20} />
                </button>
            </Modal.Header>
            <Modal.Body className="mp-modal-body">
                <p>¿Estás seguro que deseas eliminar este stock?</p>
            </Modal.Body>
            <Modal.Footer className="mp-modal-footer">
                <button className="mp-modal-btn-cancel" onClick={handleClose} disabled={loading}>
                    Cancelar
                </button>
                <button
                    className="mp-modal-btn-submit"
                    style={{ background: '#ef4444' }}
                    onClick={handleDelete}
                    disabled={loading}
                >
                    {loading ? 'Eliminando...' : 'Eliminar'}
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteStock;